import $ from 'jquery';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';
//import 'bootstrap';

import './General/Setup';
import './General/Lightbox';
import './General/Select';
import './General/BackToTop';
import './General/Datepicker';
import './General/SmoothScroll';
import './General/TwoClick';
import './General/TextImage';
import './General/Themenkompass';
import './General/Film120Seconds';
import './General/HeptaSlider';
import './General/Counter';
import './General/Search';


import './Nav/Navigation';
// import './Nav/LangMenu';

// import './Mask/Slider';
// import './Mask/Gallery';
import './Mask/Youtube';
// import './Mask/Maps';
import './Mask/Accordion';
import './Mask/GallerySlider';
import './Mask/Jsz';
import './Mask/Interferer';
import './Mask/Timeline';
import './Mask/Reels';
import './Mask/Organigramm';


import './Extensions/News/Slider';
import './Extensions/News/ListFilter';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}

// just a simple resize trigger. Nice to have.
$(window).trigger('resize');
